<div class="section_header">
  <div *ngIf="order" class="section_header_title">
    <div>
      <h2>Detalhe pedido de {{order.Feria}}</h2>
    </div>
    <div *ngIf="statusList.length>0 && showStatus" style="min-width: 250px;">
      <select2 [(ngModel)]="selectedIdStatus" [data]="statusList" [disabled]="origin=='mi-area'" class="select2"></select2>
    </div>
    <div class="section_header_buttons">
      <a class="btn-back" (click)="goBack()"><fa-icon [icon]="['fas','chevron-left']"></fa-icon> Voltar</a>
    </div>
  </div>
</div>

<div *ngIf="order" [@loadedFadeAnimation]="'visible'" class="mb-5">
  <div class="row">
    <div class="col mb-4">
      <table class="features">
        <tr>
          <td><strong>Nº de pedido</strong></td>
          <td>{{order.IdOrderClear}}</td>
        </tr>
        <tr *ngFor="let item of formDataValues">
          <td><strong>{{item.LABEL}}</strong></td>
          <td *ngIf="item.ID!='codDistrib' && item.ID!='nameDistrib' && origin=='mi-area'"> <input
              [(ngModel)]="item.VALUE" /></td>
          <td *ngIf="item.ID=='codDistrib' || item.ID=='nameDistrib' || origin=='zona-stihl'">{{item.VALUE}}</td>
        </tr>
      </table>
    </div>
  </div>
  <div *ngIf="origin == 'zona-stihl'" class="row mt-3">
    <div class="col-xxl-9">
      <h4>COMENTÁRIOS</h4>
      <textarea [(ngModel)]="order.Comment" class="form-control" rows="5" id="comment"
        placeholder="Comentários"></textarea>
    </div>
  </div>

  <button class="btn-orange" (click)="save()">guardar</button>

  <!-- <form *ngIf="this.HTML_FORM_ORDER" [@loadedFadeAnimation]="'visible'" #frm (ngSubmit)="saveFormulario()"
    id="formulario" name="myForm" class="mt-4 mb-5">
    <div [innerHtml]="this.HTML_FORM_ORDER" id="dvCustomization" class="external-html" runScripts></div>

    <div class="mb-3">
      <div class="form-text">
        * Este campo é de preenchimento obrigatório.
      </div>
      <button type="submit" class="btn-orange mt-3">Enviar</button>
    </div>
  </form> -->

</div>